import type { ThemeManifest } from "../types";

export const manifest: ThemeManifest = {
  id: "elevenlabs",
  displayName: "ElevenLabs",
  description:
    "Light, near-white background with pure black accents and pill buttons — inspired by elevenlabs.io.",
  extends: "default",
};
